import React, { useEffect, useState } from "react";
import { s3Actions, useSelector } from "inbooma-api";
import FormItem from "../../../components/FormItem";
import showNotification from "../../../helpers/showNotification";
import { getApiHost } from "../../../../Sync";

const ItemView = (props) => {
  const {
    dispatch,
    clientDoc,
    isEdit,
    clientDocsActions,
    requestPath,
    Biscuit,
    moment,
    t,
    language,
    currentUrl,
    rbac,
  } = props;
  const [savePending, setSavePending] = useState(false);
  const _editClientDoc = useSelector((state) => state["client_docs_data"].editClientDoc);
  const _addClientDoc = useSelector((state) => state["client_docs_data"].addClientDoc);
  const _addDocument = useSelector((state) => state.s3_data.addDocumentS3);

  const [edit, setEdit] = useState(isEdit);
  const itemTemp = {
    description: "",
    file: "",
  };
  const [item, setItem] = useState(isEdit ? clientDoc : itemTemp);
  const [fi, setFi] = useState(null);
  const [documentPending, setDocumentPending] = useState(false);

  useEffect(() => {
    if (_addDocument.success === "" || !documentPending) {
      return;
    }
    if (_addDocument.success === true) {
      let clone = {};
      Object.assign(clone, item);
      clone.file = _addDocument.data.Name;
      let fis = fi.name.split(".");
      let oo = "";
      for (let i = 0; i < fis.length - 1; i++) {
        oo += fis[i];
      }
      clone.description = oo;

      setItem(clone);
      showNotification("success", fi.name, t("added_${a}", { a: t("document") }), "", false);
    } else {
      showNotification("warning", "S3 Upload failed: " + _addDocument.data);
    }
    setDocumentPending(false);
  }, [_addDocument.success]);

  const onSubmit = () => {
    const clone = {};
    Object.assign(clone, item);
    clone.file = clone.file.replaceAll(/\s/g, "_");
    if (edit) {
      setItem(clone);
      if (edit) //edit
      {
        dispatch(
          clientDocsActions.editClientDoc({
            token: Biscuit.get("token"),
            body: clone,
            id: item.id,
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          }),
        );
        setSavePending(true);
      } else {
        //add
        dispatch(
          clientDocsActions.addClientDoc({
            token: Biscuit.get("token"),
            body: clone,
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          }),
        );
        setSavePending(true);
      }
    } else {
      dispatch(
        clientDocsActions.addClientDoc({
          token: Biscuit.get("token"),
          body: item,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setSavePending(true);
    }
  };

  useEffect(() => {
    if (!savePending || _editClientDoc.success === "") {
      return;
    }
    if (_editClientDoc.success === true) {
      showNotification("success", clientDoc.id);
      close();
    } else {
      showNotification("warning", null, _editClientDoc.data.message);
    }
    setSavePending(false);
  }, [_editClientDoc]);

  useEffect(() => {
    if (!savePending || _addClientDoc.success === "") {
      return;
    }
    if (_addClientDoc.success === true) {
      showNotification("success", _addClientDoc.data.id);
      close();
    } else {
      showNotification("warning", null, _addClientDoc.data.message);
    }
    setSavePending(false);
  }, [_addClientDoc]);

  const onChangeField = (e) => {
    let clone = {};
    Object.assign(clone, item);
    switch (e.target.name) {
      case "url":
        clone.url = e.target.value;
        break;
      case "description":
        clone.description = e.target.value;
        break;
    }
    setItem(clone);
  };

  const onUploadFile = (e) => {
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      setFi(files[i]);
      upload(files[i]);
    }
  };
  const upload = (file) => {
    setFi(file);
    let clone = {
      name: file.name.replaceAll(/\s/g, "_"),
      lastModified: file.lastModified,
      webkitRelativePath: file.webkitRelativePath,
      size: file.size,
      type: file.type,
    };
    console.log(clone);
    props.dispatch(
      s3Actions.addDocumentS3({
        file: clone,
        doctype: "UserDoc",
        client_id: 3,
        environment: "live",
        apiEntryPoint: getApiHost(),
        token: Biscuit.get("token"),
      }),
    );
    setDocumentPending(true);
  };
  const close = () => {
    dispatch(clientDocsActions.getClientDocsResetData());
    dispatch(clientDocsActions.getClientDocResetData());
    let returnUrl =
      typeof requestPath !== "undefined"
        ? requestPath + currentUrl.search
        : `/client_docs${currentUrl.search}`;
    window.location.replace(returnUrl);
  };

  const abortButtonRef = React.createRef();
  return (
    <>
      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        aria-hidden="false"
      >
        {item !== null && (
          <>
            <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
              <h1 className="inb-page-title">
                {edit
                  ? t("edit_${a}", { a: t("client_doc") })
                  : t("add_${a}", { a: t("client_doc") })}
              </h1>
              <div className="off-canvas__actions column">
                <button
                  type="submit"
                  className={
                    "button medium beautify beautify-" +
                    Biscuit.get("user.client_id") +
                    " button-submit round"
                  }
                  title={t("save")}
                  onClick={onSubmit}
                >
                  {!savePending && (
                    <>
                      <i className="fi fi-check"> </i>
                      <span>{t("save")}</span>
                    </>
                  )}
                  {savePending && (
                    <span>
                      <img
                        alt="RollingLoader"
                        className="rollingLoader"
                        src={"assets/img/rolling_loader.svg"}
                      />
                      {t("save")}
                    </span>
                  )}
                </button>
                <a href="#">
                  <button
                    ref={abortButtonRef}
                    type="button"
                    id="inb-tasksform-abort-button"
                    className="button hollow secondary right button-abort round"
                    title={t("close_window")}
                    onClick={() => close()}
                  >
                    <i className="fi fi-x"> </i>
                  </button>
                </a>
              </div>
            </header>
          </>
        )}
        {edit && (
          <>
            <p className="off-canvas__subtitle off-canvas__header-region">
              {typeof item.created !== "undefined" &&
                t("created_at") +
                  " " +
                  moment(item.created).format("DD.MM.YYYY HH:mm:ss") +
                  " " +
                  t("edited_by") +
                  " " +
                  item.created_by_name +
                  " | " +
                  t("last_modified_at") +
                  " " +
                  moment(item.modified).format("DD.MM.YYYY HH:mm:ss") +
                  " " +
                  t("edited_by") +
                  " " +
                  item.modified_by_name}
            </p>
          </>
        )}
        {item !== null ? (
          <>
            <form className="off-content row">
              <FormItem
                type="input"
                value={item.description}
                id={item.id}
                name="description"
                label={t("description")}
                labelStyle={{ minWidth: "240px" }}
                largeWidth="12"
                mediumWidth="12"
                smallWidth="12"
                notTiny={true}
                inputStyle={{ width: "100%" }}
                onChangeHandler={onChangeField}
              />
              <FormItem
                type="input"
                value={item.file}
                id={item.id}
                name="file"
                label={t("file")}
                labelStyle={{ minWidth: "240px" }}
                inputStyle={{ width: "100%" }}
                notTiny={true}
                largeWidth="12"
                mediumWidth="12"
                smallWidth="12"
                onChangeHandler={onChangeField}
              />
              <div className={"row large-12 medium-12 small 12"}>
                <div className={"column large-8 medium8 small-6"}>&nbsp;</div>
                {!documentPending ? (
                  <>
                    <FormItem
                      type="button"
                      link="#"
                      id={item.id}
                      name="upload"
                      inputType="file"
                      label={t("upload")}
                      onChangeHandler={onUploadFile}
                      beautify={true}
                      largeWidth="4"
                      mediumWidth="4"
                      smallWidth="6"
                    />
                  </>
                ) : (
                  <>
                    <span>
                      <img
                        alt="RollingLoader"
                        className="rollingLoader"
                        src={"assets/img/rolling_loader.svg"}
                      />
                      {t("upload")}
                    </span>
                  </>
                )}
              </div>
            </form>
          </>
        ) : (
          <div className="row" style={{ textAlign: "center" }}>
            <span>
              <img
                alt="RollingLoader"
                className="rollingLoader"
                src={"assets/img/rolling_loader.svg"}
              />
              {t("loading")}
            </span>
          </div>
        )}
      </div>
    </>
  );
};
export default ItemView;
